module.exports = __webpack_public_path__ + "static/img/15.6f44537.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/3/zh/15.png
// module id = dG/E
// module chunks = 0